/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
angular.module('app').factory('$userService', function() {
	var token = null;
	// localStorage is not defined for some browser specially wkhtml
	if (typeof localStorage !== 'undefined' && localStorage !== null) {
		token = localStorage.getItem('token')
	}
	return {
		user : null,
		token : token,
		set : function(user) {
			this.user = user;
		}
	};
}).factory('$timeService', function($sce) {
	return {
		getMoment : function(time, format, isUTC) {
			if (isUTC) {
				return moment.utc(time, format);
			} else {
				return moment(time, format);
			}
		},
		getMomentLocal : function(time, format, isUTC) {
			if (isUTC) {
				return moment.utc(time, format);
			} else {
				return moment(time, format);
			}
		},
		toLocalFromMoment : function(momentTime, format) {
			return momentTime.local().format(format);
		},
		getLocalTime : function(time, from, format) {
			if (typeof from === 'undefined') {
				from = 'YYYY-MM-DD HH:mm:ss';
			}

			if (typeof format === 'undefined') {
				format = 'MMM DD, HH:mm';
			}
			if (typeof time !== "undefined" && time !== null) {
				return $sce.trustAsHtml(moment.utc(time, from).local().format(format));
			} else {
				return $sce.trustAsHtml("NA");
			}
		},
		getUTCTime : function(time, from, format, isUTC) {

			var m = null;

			if (typeof from === 'undefined') {
				from = 'YYYY-MM-DD HH:mm:ss';
			}

			if (typeof format === 'undefined') {
				format = 'YYYY-MM-DD HH:mm:ss';
			}

			if (typeof time === 'undefined' || time === null) {
				m = moment.utc();
				return m.format(format);
			}

			if (typeof isUTC === 'undefined' || isUTC === null) {
				isUTC = false;
			}

			if (isUTC) {
				m = moment.utc(time, from);
			} else {
				m = moment(time, from).utc();
			}
			return m.format(format);
		},
		now : function(format) {
			if (typeof format === 'undefined') {
				format = 'YYYY-MM-DD HH:mm:ss';
			}
			return moment.utc().format(format);
		}
	};
}).factory('$vs', function() {
	return {
		isUnDefined : function(value) {
			return (typeof value === "undefined");
		},
		isNull : function(value) {
			return value === null || this.isUnDefined(value);
		},
		isEmpty : function(value) {
			if (this.isNull(value) || this.isUnDefined(value)) {
				return true;
			}
			if (value.length === 0) {
				return true;
			}
			return false;
		},
		isArray : function(value) {
			return Array.isArray(value);
		},
		isObj : function(value) {
			return !this.isNull(value) && typeof value === "object";
		}
	};
}).factory('$timeService', function($sce) {
	return {
		getUTCTime : function(time, from, format) {
			if (typeof from === 'undefined') {
				from = 'YYYY-MM-DD HH:mm:ss';
			}

			if (typeof format === 'undefined') {
				format = 'YYYY-MM-DD HH:mm:ss';
			}
			try {
				if (typeof time !== "undefined" && time !== null) {
					return moment(time, from).utc().format(format);
				} else {
					return null;
				}
			} catch (ex) {
				return null;
			}
		},
		getLocalTime : function(time, from, format) {
			if (typeof from === 'undefined') {
				from = 'YYYY-MM-DD HH:mm:ss';
			}

			if (typeof format === 'undefined') {
				format = 'MMM DD, HH:mm';
			}
			if (typeof time !== "undefined" && time !== null) {
				return $sce.trustAsHtml(moment.utc(time, from).local().format(format));
			} else {
				return $sce.trustAsHtml("NA");
			}
		}
	};
}).factory('$loadService', function() {
	return {
		isloading : false,
		message : null,
		load : function(message) {
			this.isloading = true;
			this.message = message;
		},
		loaded : function() {
			this.isloading = false;
		}
	};
}).factory('$postService', function($http, $userService, $loadService) {
	return function(url, postParam, callback, config, load) {
		if (typeof config === "undefined" || config === null) {
			config = {};
		}
		if (typeof load === "undefined") {
			load = true;
		}
		config.headers = {
			'Authorization' : 'bearer ' + $userService.token
		};
		if (load) {
			$loadService.load('Loading');
		}
		$http.post(url, postParam, config).then(function(response) {
			if (load) {
				$loadService.loaded();
			}
			if (typeof callback === "function") {
				callback(response);
			}
		}, function(data) { // the data parameter here is a jqXHR
			// instance
			console.log('server errors', data);
		});
	};
}).factory('$alertService', function() {
	return function(message, messagetype) {
		if (message.length === 0) {
			return;
		}
		switch (parseInt(messagetype)) {
		case 1:
			swal('Oops!', message, 'error');
			break;
		case 2:
			swal('Good to hear!', message, 'success');
			break;
		case 3:
			swal('Congratulation!', message, 'success');
			break;
		case 4:
			swal('', message, 'warning');
			break;
		case 5:// html message
			swal({
				title : '',
				html : message
			});
			break;
		default:
			swal('Hmm!', message, 'warning');
		}
	};
}).service('$getService', function($http, $userService) {
	this.promise = function(url, getParams, callback, config, load) {
		getParams.token = $userService.token;
		if (load) {
			$loadService.load('Loading');
		}
		return $http.get(url, {
			params : getParams
		}).then(function(response) {
			if (load) {
				$loadService.loaded();
			}
			if (typeof callback === "function") {
				return callback(response);
			}
		});
	};
}).factory('$inputService', function() {
	return function(name, callback) {
		swal({
			title : "Please provide " + name,
			text : "",
			type : "input",
			showCancelButton : true,
			closeOnConfirm : false,
			animation : "slide-from-top",
			inputPlaceholder : name
		}, function(input) {
			callback(input)
		});
	};
}).factory('$modalService', function($uibModal) {
	return function(template, controller, resolve, size, callbackResult, callbackDismiss) {
		var modal = $uibModal.open({
			templateUrl : template,
			controller : controller,
			size : size,
			resolve : resolve,
			backdrop : 'static',
			keyboard : false
		});
		modal.result.then(function(data) {
			if (typeof callbackResult === 'function') {
				callbackResult(data);
			}
		}, function() {
			if (typeof callbackDismiss === 'function') {
				callbackDismiss(data);
			}
		});
		return modal;
	};
}).factory('$directionService', function() {
	return {
		directionService : null,
		get : function() {
			if (typeof this.directionsService === 'undefined' || typeof this.directionsService === null) {
				this.directionsService = new google.maps.DirectionsService;
			}
			return this.directionsService;
		}
	};
}).factory('$locationService', function($http, $userService, $postService) {
	return function(latitude, longitude, callback) {
		var getParams = {
			token : $userService.token,
			latitude : latitude,
			longitude : longitude
		};
		var url = "/api/common/getAddress";
		return $http.get(url, {
			params : getParams
		}).then(function(response) {
			return callback(response);
		});
	};
}).factory('$mapService', function($directionService, $interval) {
	return {
		info : function(content, map, marker, infowindow, offset) {
			if (infowindow != null) {
				infowindow.setMap(null);
			}
			var options = {
				content : content,
			};

			if (typeof offset !== 'undefined' && offset !== null) {
				options.pixelOffset = new google.maps.Size(offset.x, offset.y)
			}
			infowindow = new google.maps.InfoWindow(options);
			infowindow.open(map);
			if (typeof marker !== 'undefined' && marker !== null) {
				infowindow.setAnchor(marker);
			}
			return infowindow;
		},
		paths : {
			arrow : 'M-0.58,50.47c-0.11-0.13-0.24-0.28-0.4-0.48c-0.02,0.03-0.04,0.05-0.04,0.05s-68.64,85.92-72.82,91.15c4.02-15.31,67.42-257.04,72.95-278.12c3.25,11.95,71.08,260.97,75.71,277.96c-0.14-0.17-0.29-0.35-0.43-0.52c-0.28-0.34-0.56-0.68-0.85-1.02c-0.35-0.42-0.7-0.84-1.05-1.26c-0.41-0.5-0.83-1-1.24-1.5c-0.48-0.57-0.95-1.14-1.43-1.71c-0.53-0.64-1.06-1.28-1.59-1.92c-0.58-0.7-1.17-1.4-1.75-2.1c-0.63-0.76-1.26-1.52-1.9-2.28c-0.68-0.81-1.35-1.63-2.03-2.44c-0.72-0.86-1.43-1.72-2.15-2.58c-0.75-0.9-1.51-1.81-2.26-2.71c-0.79-0.94-1.57-1.89-2.36-2.83c-0.81-0.98-1.63-1.95-2.44-2.93c-0.84-1.01-1.67-2.01-2.51-3.02c-0.86-1.03-1.72-2.06-2.57-3.09c-0.87-1.05-1.75-2.1-2.62-3.15c-0.89-1.06-1.77-2.13-2.66-3.19c-0.89-1.07-1.79-2.15-2.68-3.22c-0.9-1.08-1.8-2.16-2.69-3.24c-0.9-1.08-1.8-2.16-2.69-3.24c-0.89-1.07-1.79-2.15-2.68-3.22c-0.89-1.06-1.77-2.13-2.66-3.19c-0.87-1.05-1.75-2.1-2.62-3.15c-0.86-1.03-1.72-2.06-2.58-3.09c-0.84-1.01-1.68-2.01-2.52-3.02c-0.81-0.98-1.63-1.96-2.44-2.94c-0.79-0.94-1.57-1.89-2.36-2.83c-0.75-0.91-1.51-1.81-2.26-2.72c-0.72-0.86-1.44-1.73-2.16-2.59c-0.68-0.81-1.36-1.63-2.04-2.44c-0.63-0.76-1.27-1.52-1.9-2.29c-0.59-0.7-1.17-1.41-1.76-2.11c-0.53-0.64-1.07-1.28-1.6-1.93c-0.48-0.57-0.96-1.15-1.43-1.72c-0.42-0.5-0.84-1-1.25-1.51c-0.35-0.43-0.71-0.85-1.06-1.28C1.29,52.71,1,52.37,0.72,52.03c-0.21-0.26-0.43-0.51-0.64-0.77c-0.14-0.16-0.27-0.33-0.41-0.49C-0.41,50.67-0.49,50.58-0.58,50.47z',
			icon : 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
			car: 'M-26.93-35.81c1.45,5.34,2.55,9.38,2.55,9.38s0.25,0.91,0.49,1.81c1.29-1.43,3.85-1.79,5.67-2.16c2.89-0.59,5.83-0.93,8.77-1.16c7.5-0.58,15.12-0.45,22.57,0.64c3.75,0.55,7.48,1.36,11.05,2.65c0.23-0.89,0.46-1.78,0.46-1.78l8.81-33.7c0,0,0.27-1.05,0.55-2.09c-11.93-4.47-32.6-17.46-68,0.39c0.02,0.09,0.05,0.17,0.05,0.17S-29.77-46.25-26.93-35.81z M12.26,9.96c3.93,0,7.15-3.22,7.15-7.15v-15.32c0-3.93-3.22-7.15-7.15-7.15h-24.51c-3.93,0-7.15,3.22-7.15,7.15V2.81c0,3.93,3.22,7.15,7.15,7.15H12.26z M29.63,83.94c-0.3-1.21-0.69-2.5-1.16-3.89c-30.45,15.32-54.96,0-54.96,0s-0.49-0.31-1.16-0.73c-3.22,6.5-2.91,14.89-2.64,18.96c-0.47,0.9,30.07,28.63,60.16,0.28C30.26,96.19,31.67,92.03,29.63,83.94z M-19.83-136.72c-0.58-0.46-3.86,1.06-9.72,8.43c-5.86,7.36-10.09,14.4-9.51,14.86c0.58,0.46,5.71-4.44,11.58-11.8C-21.62-132.6-19.25-136.26-19.83-136.72z M39.44-113.61c0.57-0.47-0.23-4-6.19-11.28c-5.96-7.29-11.95-12.9-12.52-12.43c-0.57,0.47,3.13,6.52,9.09,13.8C35.79-116.24,38.87-113.15,39.44-113.61z M-34.87-38.71c-0.48-1.71-1.07-2.26-1.64-4.18c0,1.21,0.06,1.15,0.06,1.15v58.79c0,0,0,0.06,0,0.12c0.29,0.13,0.57,0.27,0.57,0.27l4.98,2.3c0,0,0.83,0.38,1.53,0.71C-29.35-12.04-29.61-20.06-34.87-38.71z M33.15,19.07c1.26-0.71,2.6-1.46,2.6-1.46s0.57-0.32,1.15-0.64c0-7.99,0-59.87,0-59.87s0-0.03-0.01-0.09C29.38-26.3,29.8,4.9,30.38,20.04C30.75,19.83,32.34,19.53,33.15,19.07z M-32.55,22.8c-1.61-0.5-4.07-1.27-4.32-1.34c0,0.36,0,0.63,0,0.63v45.96c0,0,0,0.27,0,0.63c0.38-0.19,5.72-2.93,5.72-2.93s0.22-0.11,0.51-0.26c0-0.55,0-41.61,0-41.61s0-0.24,0-0.48c-0.26-0.08-0.51-0.16-0.51-0.16S-31.74,23.05-32.55,22.8z M-31.05,69.21c-0.4,0.23-5.08,2.92-5.08,2.92c0,0.57,0,1.15,0,1.15v14.68c0,0,0,0.52,0,1.05c5.41-8.94,6.56-15.78,5.74-20.18c-0.32,0.18-0.63,0.36-0.63,0.36S-31.03,69.2-31.05,69.21z M32.51,67.59c1.5,0.66,3.36,1.48,3.36,1.48s0.06,0.03,0.13,0.06c0-0.41,0-0.82,0-0.82V21.83c0,0,0-0.38,0-0.77l-5.23,2.55c0,0-0.06,0.03-0.13,0.06c0,0.29,0,0.58,0,0.58v42.13c0,0,0,0.19,0,0.38C30.64,66.77,31.49,67.14,32.51,67.59z M35.62,87.19c0-4.02,0-15.32,0-15.32s0-0.04,0-0.09c-0.45-0.21-0.89-0.42-0.89-0.42l-3.96-2.04c0,0-0.83-0.22-1.02-0.31c-0.01,10.58,6.15,19.09,5.87,19.04C35.62,87.83,35.62,87.54,35.62,87.19z M41.53-117.27c0.05,0.09,0.1,0.18,0.15,0.27c0,0.1,0,0.19,0,0.19s0,63.12,0,65.48c0.36,0.18,0.64,0.32,0.64,0.32l9.06,4.6c0,0,0.32,0.16,0.74,0.38c0,0.92,0,6.77,0,6.77s0,0.44,0,0.89C51.56-38.68,51-39,51-39l-7.28-4.09c0,0-0.7-0.39-1.49-0.84c0,7.83,0,162.46,0,162.46c-0.9,1.33-1.85,2.63-2.86,3.88c-4.17,5.16-9.32,9.5-15.26,12.48c-5.31,2.67-11.14,4.22-17.05,4.73c-5.66,0.49-11.39,0.06-16.94-1.09c-5.15-1.07-10.18-2.74-14.93-5c-3.92-1.86-7.73-4.12-11.01-6.99c-1.42-1.24-2.78-2.59-3.8-4.19c-0.26-0.41-0.53-0.84-0.78-1.29c-0.34-0.62-0.64-1.26-0.82-1.93c0,0-0.24-0.84-0.4-1.45c0-0.89,0-1.79,0-2.68c0-2.08,0-4.15,0-6.23c0-3.07,0-6.15-0.01-9.22c0-3.89-0.01-7.77-0.01-11.66c0-4.51-0.01-9.03-0.01-13.54c0-4.96-0.01-9.92-0.01-14.87c0-5.22-0.01-10.44-0.01-15.65c0-5.29-0.01-10.59-0.01-15.88c0-5.18-0.01-10.37-0.01-15.55c0-4.89-0.01-9.78-0.01-14.67c0-4.41-0.01-8.83-0.01-13.24c0-3.75-0.01-7.51-0.01-11.26c0-2.91,0-5.81-0.01-8.72c0-1.88,0-3.75,0-5.63c0-0.66,0-1.32,0-1.99c0,0,0-0.03,0-0.07c-0.06,0.03-0.12,0.07-0.12,0.07l-7.99,4.2c0-0.76,0.2-1.9,0.2-1.9l0.38-4.5l7.03-5.37c0,0,0.27-0.16,0.62-0.37c0-3.74,0-64.72,0-64.72s0-0.14,0-0.28c0.16-0.16,0.32-0.32,0.32-0.32c1.02-1.02,6.29-15.41,20.43-22.66c0.06,0,0.13,0,0.13,0s39.13,0,42.14,0C31.15-134.05,35.53-127.84,41.53-117.27z',
			circle : 'M-50,0a50,50 0 1,0 100,0a50,50 0 1,0 -100,0',
			bike: 'M0.02,136.61c-0.11-0.03-0.22-0.05-0.33-0.08c-2.28-0.59-4.46-1.4-6.19-3.09c-0.81-0.79-1.29-1.71-1.28-2.88c0.02-1.17,0-2.34,0-3.51c0-0.29,0-0.58,0-0.91c-0.24-0.05-0.41-0.11-0.59-0.11c-1.3-0.02-2.61-0.06-3.91-0.02c-0.4,0.01-0.81,0.22-1.19,0.4c-0.84,0.4-1.66,0.83-2.48,1.27c-0.51,0.27-0.98,0.26-1.5-0.02c-0.95-0.52-1.94-0.97-2.92-1.45c-0.02-0.01-0.05-0.02-0.07-0.03c-0.66-0.39-0.85-2.15-0.26-2.65c0.5-0.43,0.99-0.89,1.56-1.22c1.56-0.91,3.17-0.99,4.76-0.07c0.57,0.33,1.09,0.76,1.61,1.17c0.37,0.28,0.74,0.46,1.23,0.44c0.88-0.04,1.76-0.01,2.63-0.01c1.11,0,1.11-0.01,1.11-1.08c0-1.2,0-2.39,0.01-3.59c0-0.28,0.02-0.57,0.04-0.92c0.18,0.06,0.29,0.07,0.36,0.12c0.19,0.16,0.38,0.24,0.55,0.03c0.1-0.13,0.2-0.35,0.15-0.48c-0.2-0.53,0.1-0.89,0.41-1.21c0.47-0.47,0.98-0.9,1.49-1.32c0.4-0.33,0.59-0.3,0.95,0.09c0.13,0.13,0.24,0.29,0.34,0.44c0.3,0.46,0.28,0.66-0.12,1.04c-0.44,0.42-0.92,0.8-1.37,1.22c-0.27,0.25-0.53,0.53-0.73,0.84c-0.44,0.67-0.32,1.14,0.37,1.7c0.3-0.13,0.47-0.34,0.37-0.68c-0.2-0.64,0.14-1.08,0.56-1.47c0.39-0.36,0.8-0.7,1.21-1.04c0.54-0.45,0.57-0.44,1.13,0.05c0.06,0.05,0.13,0.09,0.22,0.15c0.37-0.17,0.52-0.38,0.32-0.8c-0.29-0.6-0.26-0.61,0.24-1.06c0.23-0.21,0.43-0.44,0.68-0.7c-0.5-0.41-0.77-0.08-1.07,0.17c-0.56,0.46-0.76,0.42-1.24-0.17c-0.03-0.04-0.07-0.08-0.1-0.13c-0.48-0.62-0.48-0.62,0.05-1.19c0.18-0.19,0.36-0.39,0.53-0.59c0.03-0.03,0.03-0.1,0.05-0.18c-0.28-0.31-0.56-0.17-0.8,0.06c-0.32,0.3-0.62,0.56-1.11,0.51c-0.26-0.03-0.49,0.14-0.49,0.42c0,0.47-0.32,0.71-0.61,0.98c-0.27,0.25-0.57,0.48-0.84,0.73c-0.45,0.4-0.89,0.82-1.33,1.23c-0.42-0.83-0.31-1.64,0.33-2.21c0.58-0.51,1.18-0.99,1.77-1.48c0.12-0.1,0.29-0.18,0.35-0.31c0.06-0.14,0.02-0.33,0.02-0.49c-0.15,0-0.33-0.05-0.43,0.02c-0.35,0.24-0.66,0.53-1,0.79c-0.33,0.26-0.67,0.51-1.08,0.83c-0.08-0.26-0.15-0.42-0.16-0.58c-0.02-0.29,0.01-0.59-0.02-0.88c-0.07-0.69,0.14-1.25,0.7-1.67c0.26-0.2,0.51-0.44,0.09-0.8c-0.19,0.06-0.41,0.12-0.71,0.21c-0.03-0.28-0.08-0.51-0.08-0.73c-0.01-0.93-0.02-1.86,0.01-2.79c0.02-0.67-0.28-1.16-0.73-1.61c-0.81-0.82-1.66-1.62-2.41-2.49c-1.78-2.07-3.42-4.25-4.81-6.61c-1.23-2.08-2.3-4.22-3.12-6.5c-0.44-1.22-0.93-2.42-1.31-3.66c-0.34-1.09-0.59-2.21-0.81-3.32c-0.32-1.59-0.64-3.18-0.88-4.78c-0.27-1.81-0.43-3.64-0.69-5.45c-0.65-4.62-0.75-9.28-0.73-13.93c0.02-6.28,0.23-12.55,0.37-18.83c0-0.23,0.05-0.46,0.1-0.79c0.27,0.11,0.46,0.17,0.64,0.25c0.65,0.28,1.83-0.33,1.95-1.02c0.08-0.47-0.11-0.83-0.49-1.1c-0.38-0.26-0.76-0.38-1.18-0.09c-0.17,0.12-0.33,0.23-0.53,0.37c-0.22-0.37-0.04-0.61,0.13-0.83c0.3-0.38,0.39-0.71,0.03-1.13c-0.15-0.17-0.18-0.5-0.17-0.75c0.02-0.56,0.08-1.11,0.16-1.67c0.24-1.6,0.46-3.21,0.77-4.8c0.26-1.33,0.62-2.63,0.94-3.95c0.08-0.33,0.16-0.66,0.26-1.04c-0.24-0.06-0.41-0.13-0.58-0.13c-1.2-0.01-2.39-0.02-3.59-0.01c-0.63,0.01-0.69,0.07-0.71,0.68c-0.02,0.5,0.02,1.01-0.03,1.51c-0.06,0.62-0.25,0.66-0.81,0.36c-0.24-0.13-0.55-0.21-0.82-0.21c-2.82-0.02-5.63-0.01-8.45-0.01c-0.33,0-0.6,0.05-0.87,0.29c-0.33,0.29-0.64,0.16-0.75-0.28c-0.04-0.15-0.04-0.32-0.04-0.48c0-1.54,0-3.09,0-4.63c0-0.11-0.01-0.22,0.01-0.32c0.08-0.41,0.37-0.52,0.76-0.35c0.28,0.12,0.59,0.23,0.89,0.24c2.79,0.02,5.59,0.02,8.38,0c0.35,0,0.71-0.15,1.06-0.26c0.36-0.12,0.58-0.04,0.64,0.33c0.05,0.37,0.02,0.74,0.04,1.11c0.03,0.66,0.11,0.77,0.73,0.78c1.22,0.01,2.45,0.01,3.67-0.02c0.58-0.01,0.78-0.15,0.86-0.74c0.23-1.83,0.92-3.54,1.39-5.31c0.31-1.16,0.95-2.19,1.63-3.17c0.12-0.17,0.21-0.36,0.29-0.48c-0.03-0.37-0.61-0.5-0.28-0.88c0.32-0.36,0.56,0.02,0.9,0.22c0.17-0.22,0.39-0.41,0.48-0.65c0.12-0.32,0.16-0.67,0.19-1.01c0.11-1.14,0.21-2.28,0.31-3.41c0.02-0.19,0.02-0.37,0.02-0.56c0-0.33-0.17-0.49-0.51-0.46c-0.13,0.01-0.26,0.06-0.39,0.06c-0.79,0.04-1.13-0.27-1.12-1.06c0.01-0.5-0.04-1,0.24-1.47c0.36-0.61,0.8-0.98,1.55-0.84c0.07,0.01,0.15-0.02,0.33-0.05c0.03-0.23,0.09-0.48,0.1-0.73c0.04-2.95-0.05-5.9-0.29-8.85c-0.09-1.11-0.13-2.23-0.21-3.34c-0.11-1.48-0.19-2.97-0.36-4.45c-0.07-0.62-0.35-1.22-0.57-1.81c-0.23-0.62-0.51-1.22-0.75-1.84c-0.35-0.94-0.68-1.9-1.02-2.84c-0.21-0.6-0.43-1.19-0.65-1.79c-0.16-0.45-0.32-0.9-0.47-1.35c-0.31-0.9-0.59-1.81-0.92-2.7c-0.76-2.09-1.58-4.15-2.04-6.35c-0.29-1.42-0.42-2.83-0.53-4.26c-0.18-2.27-0.06-4.53,0.28-6.76c0.35-2.3,0.98-4.55,1.91-6.72c0.9-2.11,1.99-4.11,3.43-5.87c1.77-2.14,3.89-3.9,6.52-4.93c1.14-0.45,2.34-0.7,3.56-0.85c0.93-0.11,0.98-0.16,0.82-1.1c-0.21-1.31-0.46-2.61-0.67-3.92c-0.15-0.94-0.28-1.89-0.41-2.83c-0.01-0.09,0.06-0.19,0.1-0.3c0.4,0,0.4,0.28,0.48,0.53c0.13,0.42,0.23,0.9,0.49,1.24c0.64,0.83,1.71,0.97,2.65,0.39c0.4-0.24,0.77-0.56,1.09-0.91c0.7-0.76,1.49-1.24,2.58-1.17c1.11,0.06,2.23,0.06,3.35,0.06c0.93,0,1.86-0.02,2.79-0.05c0.83-0.03,1.49,0.32,2.06,0.88c0.36,0.35,0.72,0.7,1.11,1.01c1.1,0.88,2.98,0.76,3.5-1.43c0.07-0.31,0.06-0.31,0.38-0.6c0.02,0.22,0.07,0.39,0.05,0.54c-0.25,1.49-0.52,2.98-0.76,4.47c-0.14,0.87-0.22,1.74-0.33,2.61c-0.04,0.31,0.12,0.45,0.38,0.5c0.34,0.06,0.68,0.1,1.03,0.15c3.14,0.45,5.75,1.91,8.02,4.08c1.58,1.52,2.8,3.29,3.85,5.21c0.95,1.73,1.67,3.55,2.17,5.45c0.28,1.08,0.6,2.15,0.83,3.24c0.14,0.65,0.16,1.32,0.22,1.98c0.18,2.07,0.17,4.14,0.05,6.22c-0.09,1.5-0.46,2.94-0.79,4.38c-0.27,1.16-0.64,2.3-1,3.44c-0.3,0.94-0.65,1.86-0.99,2.78c-0.06,0.17-0.15,0.35-0.28,0.47c-0.26,0.24-0.28,0.53-0.35,0.85c-0.14,0.64-0.36,1.27-0.59,1.89c-0.7,1.95-1.41,3.89-2.14,5.83c-0.55,1.46-1.17,2.89-1.73,4.34c-0.45,1.16-0.84,2.35-1.28,3.52c-0.69,1.84-1.4,3.67-2.09,5.51c-0.27,0.71-0.5,1.44-0.79,2.25c0.78,0.12,1.48,0.3,2.18,0.33c1.67,0.07,3.35,0.07,5.03,0.08c0.88,0.01,1.2,0.47,0.81,1.28c-0.32,0.67-0.88,1.05-1.63,1.1c-0.41,0.03-0.83,0.05-1.29,0.22c0.15,0.12,0.29,0.25,0.45,0.35c1.21,0.72,2,1.79,2.63,3.01c1.09,2.11,1.31,4.4,1.45,6.71c0.04,0.63-0.1,1.27,0.17,1.94c0.14-0.09,0.27-0.14,0.34-0.23c1.51-2.08,2.87-4.26,4.13-6.51c0.21-0.37,0.4-0.75,0.65-1.09c0.44-0.63,0.67-1.3,0.71-2.07c0.05-0.92,0.14-1.01,1.04-1.04c0.98-0.03,1.97-0.04,2.95,0c0.67,0.03,0.85,0.21,0.9,0.87c0.04,0.55,0.02,1.12-0.04,1.67c-0.06,0.55-0.2,0.68-0.77,0.73c-0.71,0.06-1.44,0.12-2.15,0.07c-0.8-0.05-1.36,0.19-1.75,0.92c-0.3,0.55-0.69,1.06-1.08,1.56c-0.22,0.29-0.52,0.51-0.75,0.79c-0.33,0.41-0.66,0.82-0.92,1.27c-0.21,0.38-0.64,0.68-0.53,1.21c0.01,0.04-0.04,0.12-0.07,0.12c-0.5,0.06-0.24,0.42-0.24,0.69c-0.21,0.06-0.4,0.12-0.61,0.18c0.01,0.1-0.01,0.19,0.02,0.24c0.22,0.37,0.2,0.53-0.12,0.49c-0.41-0.05-0.5,0.2-0.65,0.44c-0.19,0.35-0.62,0.59-0.54,1.05c0.06,0.02,0.12,0.04,0.18,0.06c0.12-0.38,0.24-0.76,0.35-1.14c0.15,0,0.31,0,0.56,0c-0.26,0.51-0.5,0.97-0.74,1.43c-0.06,0.12-0.14,0.23-0.21,0.34c-0.6,0.91-0.74,1.9-0.64,2.97c0.09,0.92,0.07,1.86,0.11,2.79c0.01,0.26,0.04,0.52,0.06,0.84c0.34,0.04,0.62,0.09,0.9,0.09c1.12,0.01,2.23,0,3.35,0c0.74,0,0.86-0.13,0.89-0.9c0.01-0.35-0.02-0.69,0.03-1.04c0.05-0.4,0.28-0.52,0.6-0.27c0.28,0.21,0.57,0.25,0.89,0.25c2.82,0,5.64,0,8.46,0c0.34,0,0.65,0.01,0.96-0.25c0.31-0.26,0.59-0.08,0.66,0.34c0.02,0.16,0.02,0.32,0.02,0.48c0,1.44,0,2.87,0,4.31c0,0.16,0.02,0.33-0.02,0.48c-0.07,0.21-0.15,0.45-0.3,0.58c-0.06,0.05-0.33-0.15-0.51-0.22c-0.19-0.07-0.38-0.18-0.58-0.18c-2.93-0.01-5.85-0.02-8.78,0c-0.26,0-0.52,0.19-0.78,0.29c-0.14,0.05-0.28,0.11-0.53,0.21c-0.04-0.43-0.09-0.79-0.11-1.15c-0.02-0.4-0.02-0.8-0.03-1.2c-0.01-0.27-0.13-0.49-0.42-0.49c-1.46-0.01-2.91-0.01-4.39-0.01c-0.04,0.24-0.1,0.4-0.08,0.55c0.15,1,0.31,1.99,0.47,2.99c0.3,1.89,0.87,3.73,0.88,5.67c0,0.18,0.01,0.38,0.07,0.55c0.36,1.02,0.32,2.1,0.45,3.15c0.37,2.93,0.42,5.88,0.53,8.83c0.11,3,0.33,6,0.31,9c-0.03,4.39-0.26,8.77-0.34,13.15c-0.05,2.59-0.45,5.13-0.64,7.7c-0.09,1.19-0.31,2.37-0.53,3.55c-0.57,2.97-1.13,5.95-2.1,8.83c-0.4,1.18-0.71,2.4-1.21,3.53c-0.75,1.69-1.43,3.42-2.48,4.96c-0.99,1.46-1.84,3.03-2.9,4.44c-1.24,1.64-2.64,3.16-3.98,4.72c-0.36,0.42-0.76,0.8-1.13,1.21c-0.26,0.29-0.38,0.62-0.38,1.02c0.01,4.47,0.02,8.94,0.02,13.4c0,0.85-0.01,1.7-0.01,2.55c0,0.93,0.04,0.97,0.93,0.97c0.96,0.01,1.92-0.01,2.87,0.01c0.48,0.01,0.87-0.16,1.24-0.45c0.44-0.34,0.88-0.68,1.34-1c1.68-1.15,3.99-1.03,5.55,0.28c0.3,0.26,0.58,0.56,0.91,0.77c0.34,0.21,0.48,0.5,0.45,0.86c-0.03,0.47-0.08,0.95-0.19,1.42c-0.04,0.17-0.24,0.36-0.41,0.45c-1.01,0.52-2.05,0.99-3.05,1.53c-0.53,0.28-0.99,0.24-1.5-0.03c-0.98-0.52-1.98-1.01-2.98-1.5c-0.18-0.09-0.4-0.17-0.59-0.17c-1.2,0-2.39,0.03-3.59,0.05c-0.93,0.01-0.95,0.02-0.97,0.93c-0.02,1.22-0.02,2.45-0.02,3.67c0.01,1.29-0.54,2.31-1.51,3.11c-0.86,0.71-1.76,1.37-2.81,1.7c0-0.35-0.02-0.68,0.01-1.01c0.01-0.2,0.03-0.47,0.16-0.57c1.21-0.95,1.62-2.33,2-3.71c0.33-1.2,0.59-2.42,0.88-3.63c0.02-0.07-0.01-0.15-0.02-0.28c-0.14-0.04-0.28-0.1-0.43-0.11c-0.37-0.02-0.59-0.24-0.69-0.57c-0.16-0.53-0.3-1.07-0.48-1.68c0.21-0.06,0.39-0.14,0.59-0.16c0.32-0.03,0.64-0.02,0.96-0.04c0.37-0.02,0.59-0.21,0.62-0.59c0.04-0.42,0.12-0.85,0.12-1.27c0.02-2.74,0.04-5.48,0.01-8.22c-0.01-0.82-0.18-1.63-0.27-2.45c-0.07-0.61-0.11-1.22-0.19-1.82c-0.06-0.44-0.15-0.87-0.24-1.39c-0.77,0.58-1.37,1.14-2.08,1.54c-0.68,0.39-1.45,0.6-2.23,0.92c0.27,0.9,0.56,1.77,0.79,2.66c0.15,0.59,0.16,1.22,0.35,1.79c0.32,0.96,0.29,1.94,0.23,2.92c-0.06,0.87-0.36,1.68-0.73,2.61c-0.32-0.31-0.56-0.5-0.76-0.73c-0.76-0.9-1.57-1.73-2.62-2.3c-0.38-0.21-0.5-0.52-0.51-0.92c-0.02-0.53-0.04-1.06-0.08-1.59c-0.04-0.5-0.33-0.82-0.77-1.04c-0.93-0.45-1.85-0.43-2.73,0.13c-0.38,0.24-0.6,0.58-0.6,1.06c0,0.45-0.06,0.91-0.03,1.35c0.04,0.49-0.15,0.8-0.57,1.04c-0.64,0.37-1.31,0.72-1.89,1.18c-0.83,0.65-1.64,1.35-2.36,2.12c-0.29,0.31-0.34,0.87-0.47,1.32c-0.11,0.37-0.18,0.76-0.31,1.13c-0.31,0.93-0.7,1.84-0.96,2.78c-0.26,0.92-0.12,1.11,0.76,1.41c1.89,0.63,3.82,1.13,5.81,1.37c0.32,0.04,0.63,0.08,0.95,0.14c0.66,0.14,1.31,0.16,1.97,0.01c0.45-0.1,0.93-0.08,1.46-0.12c-0.48,0.9-1.13,1.31-1.95,1.33c-2.23,0.04-4.39-0.4-6.51-1c-0.59-0.17-1.16-0.39-1.74-0.58c-0.19-0.06-0.4-0.09-0.72-0.17c0.08,0.26,0.1,0.44,0.19,0.57c0.73,1.04,1.78,1.64,2.92,2.12c2.13,0.9,4.35,1.11,6.63,1c0.39-0.02,0.79,0.05,1.24,0.08c0.06,0.28,0.11,0.54,0.16,0.79c0.19,0.86,0.58,1.58,1.39,2.03c0.53,0.3,1.01,0.67,1.53,1.02c-0.51,0.29-1.06,0.47-1.62,0.62 M16.94-8.04C16.99-8.02,17.04-8,17.1-7.99c0.13-0.27,0.28-0.54,0.4-0.82c0.29-0.65,0.57-1.31,0.85-1.97c0.45-1.04,0.92-2.08,1.36-3.13c0.69-1.64,1.36-3.29,2.03-4.93c0.37-0.9,0.75-1.8,1.09-2.71c0.29-0.77,0.52-1.56,0.77-2.34c0.48-1.49,0.98-2.97,1.44-4.47c0.26-0.86,0.41-1.75,0.69-2.61c0.6-1.83,0.94-3.72,1.06-5.62c0.26-3.98-0.16-7.89-1.65-11.64c-0.31-0.77-0.75-1.41-1.37-1.92c-0.49-0.41-1.07-0.71-1.73-0.72c-0.7-0.01-1.1,0.37-1.1,1.07c0,0.26,0.04,0.53,0.09,0.79c0.17,0.83,0.34,1.66,0.53,2.49c0.62,2.63,0.47,5.29,0.2,7.93c-0.25,2.43-0.69,4.83-1.07,7.25c-0.29,1.86-0.59,3.73-0.89,5.59c-0.18,1.1-0.38,2.2-0.55,3.29c-0.22,1.36-0.41,2.73-0.64,4.09c-0.52,3.04-1.06,6.07-1.58,9.1C16.97-8.86,16.97-8.45,16.94-8.04z M9.94-46.05c-0.19,2.56,1.89,4.47,4.24,4.49c2.76,0.03,4.43-2.12,4.5-4.3c0.08-2.41-2.04-4.5-4.39-4.51C12.07-50.37,9.76-48.43,9.94-46.05z M4.69-133.1c0.35,0.12,0.68,0.3,1.04,0.36c1.22,0.21,2.35,0.66,3.4,1.3c1.14,0.7,1.86,1.66,1.77,3.06c-0.04,0.52,0.15,0.84,0.6,1.09c0.32,0.17,0.61,0.42,0.9,0.64c1.14,0.87,1.79,1.97,1.78,3.45c-0.02,3.62,0,7.23,0,10.85c0,1.3,0,2.61-0.01,3.91c0,0.25-0.04,0.51-0.06,0.85c-0.38-0.19-0.67-0.31-0.93-0.47c-0.31-0.19-0.37-0.5-0.32-0.84c0.32-2.3,0.26-4.62,0.23-6.93c-0.01-0.82-0.14-1.64-0.22-2.46c-0.06-0.61-0.13-1.22-0.21-1.82c-0.21-1.54-0.56-3.04-1.37-4.37c-0.71-1.17-1.79-1.93-3.03-2.48c-0.88-0.39-1.8-0.67-2.76-0.72c-0.57-0.03-1.16,0.06-1.73,0.16c-0.47,0.09-0.57,0.27-0.43,0.75c0.31,1.04,0.6,2.1,1,3.11c1.09,2.68,2.23,5.33,3.36,8c0.07,0.17,0.14,0.34,0.21,0.52c0.41,1,0.05,1.51-1.03,1.43c-0.32-0.02-0.55,0.04-0.56,0.38c-0.01,0.45-0.28,0.66-0.62,0.85c-0.14,0.08-0.27,0.17-0.4,0.26c-0.74,0.56-1.59,1.04-1.49,2.24c-0.46,0.03-0.85,0.08-1.24,0.08c-2.71,0.02-5.34,0.44-7.9,1.34c-0.77,0.27-1.51,0.61-2.38,0.96c-0.03-0.34-0.08-0.65-0.08-0.95c0-4.41,0-8.83,0.01-13.24c0-0.53,0-1.06,0.01-1.6c0.03-1.66,1.02-2.72,2.26-3.61c0.18-0.13,0.46-0.23,0.65,0.03c0.19,0.27,0.06,0.5-0.16,0.7c-0.61,0.55-1.23,1.09-1.81,1.67c-0.51,0.51-0.56,1.14-0.23,1.67c0.13,0.21,0.3,0.45,0.56,0.28c0.13-0.08,0.25-0.36,0.21-0.51c-0.17-0.67,0.12-1.13,0.59-1.54c0.36-0.31,0.71-0.64,1.08-0.94c0.42-0.34,0.65-0.33,1.04,0.03c0.1,0.09,0.18,0.19,0.27,0.29c0.5,0.6,0.5,0.72-0.03,1.26c-0.56,0.57-1.15,1.1-1.68,1.7c-0.57,0.64-0.52,1.21,0.1,1.93c0.35-0.09,0.65-0.21,0.47-0.69c-0.21-0.56,0.08-0.99,0.43-1.36c0.35-0.36,0.75-0.68,1.13-1c0.54-0.45,0.57-0.46,1.18-0.11c0.19,0.11,0.41,0.26,0.55,0.03c0.09-0.14,0.11-0.41,0.05-0.57c-0.27-0.69-0.29-0.68,0.21-1.18c0.15-0.15,0.29-0.31,0.43-0.47c0.03-0.04,0.03-0.1,0.07-0.2c-0.34-0.28-0.63-0.2-0.95,0.07c-0.76,0.66-0.77,0.65-1.48-0.1c-0.57-0.59-0.57-0.73-0.04-1.32c0.09-0.1,0.22-0.17,0.27-0.28c0.07-0.15,0.07-0.33,0.11-0.49c-0.19-0.02-0.41-0.1-0.58-0.04c-0.16,0.05-0.27,0.24-0.41,0.37c-0.2,0.19-0.44,0.4-0.69,0.2c-0.18-0.14-0.33-0.42-0.35-0.65c-0.12-1.46,0.65-2.47,1.81-3.22c1.04-0.67,2.18-1.09,3.4-1.31c0.33-0.06,0.63-0.23,0.95-0.35C2.67-133.1,3.68-133.1,4.69-133.1z M32.03-78.65c0.33-0.91,0.61-1.7,0.92-2.57c0.32,0.07,0.6,0.1,0.86,0.19c1.48,0.5,2.97,1,4.44,1.52c0.63,0.22,1.24,0.17,1.88,0.06c0.6-0.1,1.21-0.13,1.82-0.12c0.56,0.01,1.08,0.27,1.28,0.79c0.21,0.54,0.07,1.12-0.44,1.51c-0.41,0.31-0.51,0.68-0.44,1.18c0.06,0.46,0.01,0.94,0.01,1.36c-0.51,0.03-0.91,0.1-1.31,0.06c-0.52-0.04-0.64,0.39-0.88,0.7c-0.26-0.07-0.48-0.13-0.77-0.21c-0.14,0.29-0.28,0.57-0.46,0.94c-1.78-0.33-3.43-1.24-5.31-1.6c-0.3,0.92-0.6,1.79-0.88,2.67c-0.04,0.12-0.04,0.28,0.01,0.39c0.42,0.97-0.06,1.83-0.34,2.69c-0.14,0.41-0.46,0.76-0.7,1.14c-0.17,0.26-0.43,0.31-0.71,0.22c-0.8-0.27-1.6-0.56-2.4-0.85c-0.04-0.01-0.06-0.08-0.13-0.2c0.69-0.63,0.95-1.51,1.22-2.39c0.03-0.1,0.1-0.21,0.09-0.3c-0.12-1,0.45-1.82,0.71-2.72c0.26-0.89,0.57-1.77,0.9-2.64c0.5-1.34,0.51-1.42-0.81-1.88c-1.48-0.51-2.96-1.06-4.49-1.37c-1.71-0.35-3.47-0.5-5.24-0.39c-1.08,0.07-2.16,0.18-3.31,0.28c-0.19,1.51,0.02,2.94-0.14,4.43c-0.31,0.02-0.56,0.05-0.82,0.06c-0.82,0.01-1.65,0-2.47,0c-0.4,0-0.71,0.12-1.06,0.4c-0.96,0.75-2.01,1.2-3.32,0.78c-1.49-0.47-3.02-0.83-4.54-1.16c-0.67-0.14-1.37-0.11-2.06-0.13c-0.88-0.02-1.76-0.03-2.63,0c-1.14,0.04-2.09-0.36-2.81-1.24c-0.38-0.46-0.83-0.8-1.36-1.06c-1.28-0.63-2.29,0.04-2.78,1.14c-0.12,0.26-0.17,0.56-0.23,0.84c-0.06,0.27-0.21,0.42-0.49,0.42c-1.25,0-2.49,0-3.74,0c-0.36-0.7-0.06-1.42-0.28-2.19c-0.48-0.13-1.01-0.31-1.54-0.42c-3.21-0.66-6.46-0.99-9.74-0.83c-0.82,0.04-1.64,0.1-2.47,0.17c-0.2,0.02-0.4,0.09-0.64,0.14c0.01,0.17-0.01,0.31,0.03,0.42c0.5,1.51,1.01,3.02,1.51,4.53c0.06,0.18,0.1,0.36,0.19,0.53c0.26,0.5,0.33,1.02,0.4,1.57c0.13,0.99,0.5,1.95,1.16,2.75c0.08,0.1,0.16,0.19,0.31,0.38c-0.31,0.12-0.55,0.21-0.78,0.29c-0.53,0.19-1.05,0.37-1.58,0.55c-0.58,0.2-0.84,0.15-1.16-0.36c-0.68-1.1-1.23-2.24-0.85-3.6c0.04-0.15,0.05-0.33,0.01-0.47c-0.29-0.85-0.59-1.69-0.91-2.58c-1.87,0.3-3.48,1.24-5.26,1.58c-0.18-0.37-0.34-0.67-0.5-0.99c-0.27,0.1-0.49,0.18-0.74,0.27c-0.46-0.88-1.21-0.89-2.06-0.7c-0.32-0.47-0.25-1.01-0.14-1.52c0.1-0.46,0.04-0.77-0.36-1.02c-0.11-0.07-0.19-0.19-0.27-0.29c-0.64-0.86-0.43-1.69,0.61-1.98c0.57-0.16,1.23-0.19,1.8-0.06c1.29,0.31,2.46,0.04,3.65-0.43c1.13-0.45,2.3-0.82,3.45-1.21c0.16-0.06,0.36-0.03,0.57-0.04c0.15,0.42,0.26,0.83,0.44,1.21c0.3,0.64,0.32,0.63,1.04,0.55c2.52-0.28,5.05-0.29,7.57-0.06c1.71,0.16,3.41,0.51,5.12,0.79c0.38,0.06,0.71,0.42,1.2,0.13c0.02-0.21,0.06-0.47,0.06-0.72c0-2.23-0.01-4.47,0.01-6.7c0-0.55-0.16-0.96-0.58-1.32c-0.42-0.36-0.78-0.78-1.17-1.18c-0.29-0.3-0.63-0.45-1.06-0.45c-2.55,0.01-5.11,0.02-7.66-0.01c-0.6-0.01-0.99,0.29-1.4,0.64c-0.43,0.38-0.86,0.77-1.42,0.93c-0.81-1.13-1.01-1.25-1.74-1.13c-0.25,0.04-0.49,0.1-0.36,0.5c0.19,0.02,0.39,0.05,0.59,0.06c0.34,0.01,0.56,0.19,0.61,0.52c0.05,0.34-0.18,0.61-0.48,0.63c-0.63,0.05-1.29,0.11-1.88-0.03c-1.15-0.27-2.12-0.92-2.96-1.76c-0.25-0.25-0.39-0.49-0.37-0.83c0.03-0.5,0.07-1.01,0.11-1.58c0.99-0.5,2.04-0.95,3.01-1.54c0.87-0.52,1.61-0.57,2.48,0.01c0.74,0.49,1.6,0.82,2.42,1.2c0.26,0.12,0.55,0.2,0.83,0.2c2.69,0.01,5.37-0.01,8.06,0c0.55,0,0.97-0.14,1.33-0.56c0.31-0.36,0.65-0.69,1.01-1.01c0.47-0.42,0.7-0.91,0.64-1.55c-0.03-0.39-0.01-0.78,0.1-1.2c1.35,2.39,2.72,4.72,4.51,6.78c0.07-0.02,0.14-0.04,0.21-0.05c0.01-0.24,0.02-0.49,0.02-0.73c-0.09-2.72,0.64-5.13,2.58-7.13c2.6-2.68,6.47-3,9.2-1.36c0.68,0.41,1.33,0.84,1.88,1.43c0.6,0.64,1.38,1.03,2.26,1.03c0.82,0.01,1.64-0.06,2.46-0.18c0.81-0.12,1.61-0.36,2.41-0.52c0.28-0.06,0.58-0.09,0.87-0.05c0.56,0.07,1.02,0.3,1.09,0.96c0.02,0.17,0.12,0.33,0.22,0.6c0.23-0.4,0.4-0.7,0.57-1c0.05,0.01,0.1,0.02,0.15,0.03c0.01,0.22,0.04,0.44,0.04,0.66c0.01,0.35,0.01,0.69,0,1.04c0,0.39,0.11,0.71,0.4,1c0.48,0.45,0.92,0.95,1.39,1.41c0.29,0.28,0.64,0.41,1.08,0.4c2.74-0.01,5.48,0.04,8.22-0.02c0.57-0.01,1.15-0.36,1.69-0.62c0.74-0.35,1.46-0.75,2.19-1.13c0.38-0.2,0.74-0.19,1.14,0.02c0.92,0.48,1.83,0.97,2.79,1.36c0.91,0.37,0.91,1.15,1.02,1.89c0.07,0.45-0.08,0.81-0.48,1.09c-0.73,0.52-1.36,1.14-2.23,1.48c-1.69,0.65-3.17,0.26-4.6-0.67c-0.22-0.14-0.46-0.28-0.63-0.48c-0.58-0.68-1.33-0.79-2.15-0.78c-2.31,0.03-4.63,0.05-6.94,0.05c-0.44,0-0.78,0.13-1.07,0.41c-0.48,0.46-0.96,0.91-1.4,1.39c-0.18,0.2-0.37,0.49-0.38,0.74c-0.03,1.86-0.02,3.71-0.02,5.67c0.44,0,0.83,0.05,1.21-0.01c2.29-0.33,4.57-0.26,6.83,0.12c1.8,0.3,3.58,0.78,5.26,1.53C31.2-78.93,31.57-78.81,32.03-78.65z M-28.93-70.74c-0.26,0.28-0.6,0.48-0.61,0.69c0,0.52,0.13,1.05,0.25,1.56c0.07,0.28,0.24,0.53,0.34,0.8c0.27,0.72,0.38,0.8,1.14,0.8c0.2,0.75,0.15,0.86-0.56,1.08c-0.36,0.11-0.67,0.23-0.8,0.67c-0.12,0.42-0.7,0.63-1.03,0.37c-0.37-0.29-0.69-0.17-1.04-0.06c-0.43,0.14-0.85,0.3-1.32,0.46c-0.04,0.2-0.09,0.42-0.15,0.67c-0.26,0.09-0.5,0.18-0.88,0.32c-0.08-0.15-0.18-0.34-0.28-0.52c-0.67,0.24-1.26,0.44-1.91,0.22c-0.21-0.07-0.51,0.1-0.76,0.18c-2.24,0.75-4.47,1.5-6.7,2.28c-1.93,0.67-3.85,1.37-5.78,2.06c-0.52,0.19-0.69,0.17-1.03-0.29c-0.7-0.97-1.08-2.06-1.11-3.26c-0.01-0.44,0.22-0.68,0.62-0.82c1.33-0.46,2.65-0.93,3.97-1.39c2.05-0.72,4.1-1.44,6.15-2.15c0.88-0.3,1.77-0.56,2.63-0.89c0.3-0.11,0.54-0.38,0.82-0.57c0.22-0.14,0.43-0.32,0.67-0.4c2.08-0.74,4.16-1.45,6.24-2.19C-29.59-71.3-29.28-71.09-28.93-70.74z M40.35-63.81c-0.29,0.41-0.7,0.46-1.2,0.05c-0.03-0.17-0.07-0.4-0.11-0.6c-0.47-0.16-0.89-0.32-1.31-0.46c-0.37-0.12-0.73-0.26-1.12,0.07c-0.26,0.22-0.88,0.02-0.94-0.3c-0.1-0.53-0.48-0.64-0.88-0.78c-0.19-0.07-0.41-0.15-0.53-0.3c-0.31-0.36-0.17-0.72,0.3-0.75c0.44-0.03,0.67-0.24,0.79-0.64c0.17-0.56,0.36-1.1,0.57-1.65c0.23-0.61,0.28-1.14-0.46-1.41c0.37-0.65,0.48-0.71,1.06-0.51c2.09,0.71,4.17,1.43,6.25,2.15c0.22,0.08,0.52,0.17,0.61,0.34c0.31,0.56,0.88,0.66,1.39,0.85c1.22,0.45,2.45,0.86,3.68,1.27c2.03,0.69,4.07,1.36,6.1,2.05c0.85,0.29,1.69,0.62,2.54,0.92c0.32,0.11,0.49,0.32,0.48,0.65c-0.02,0.48,0.02,0.98-0.13,1.42c-0.23,0.7-0.54,1.38-0.93,2c-0.32,0.51-0.53,0.5-1.09,0.3c-2.35-0.84-4.69-1.7-7.04-2.52c-1.85-0.65-3.71-1.28-5.58-1.89c-0.31-0.1-0.67-0.04-1-0.07C41.36-63.67,40.89-63.74,40.35-63.81z M10.15-105.59c-0.45,0.58-0.85,1.09-1.33,1.69c-1.63-0.12-3.4-0.35-5.17-0.34c-1.8,0-3.61,0.14-5.4,0.38c-1.76,0.24-3.51,0.61-5.22,1.06c-1.71,0.45-3.38,1.06-5.12,1.62c-0.19-0.61-0.13-1.22-0.07-1.81c0.01-0.15,0.24-0.35,0.41-0.41c1.56-0.51,3.12-1.03,4.7-1.48c1.2-0.34,2.41-0.63,3.64-0.88c3.09-0.61,6.2-0.9,9.35-0.55c0.54,0.06,1.04,0.18,1.46,0.55c0.44,0.39,0.93,0.43,1.48,0.19C9.29-105.74,9.72-105.97,10.15-105.59z M-20.47,9.09c-0.09,0.52-0.13,1.08-0.29,1.61c-0.17,0.53-0.44,1.06-1.09,1.14c-0.68,0.08-1.35,0.01-1.76-0.65c-0.25-0.4-0.52-0.81-0.7-1.24c-0.54-1.25-0.98-2.53-0.71-3.93c0.14-0.72,0.33-1.49,1.13-1.68c0.87-0.2,1.73,0.06,2.28,0.8c0.37,0.5,0.67,1.1,0.83,1.7C-20.59,7.54-20.57,8.3-20.47,9.09z M-25.28,2.14c-0.22,0.82-0.39,1.51-0.58,2.19c-0.09,0.33-0.37,0.34-0.64,0.34c-0.8,0-1.59,0-2.39,0c-0.5,0-1.01-0.01-1.51-0.02c-0.35-0.01-0.65,0-0.93,0.31c-0.27,0.3-0.73,0.13-0.75-0.28c-0.05-0.87-0.05-1.75,0-2.63c0.03-0.47,0.43-0.6,0.79-0.27c0.3,0.27,0.61,0.27,0.96,0.27c1.41,0,2.81,0,4.22,0.01C-25.88,2.06-25.64,2.1-25.28,2.14z M-17.69,2.88c-0.06,0.12-0.13,0.35-0.26,0.55c-0.5,0.73-1.12,1.33-1.88,1.79c-0.33,0.19-0.63,0.22-0.97,0.02c-0.97-0.57-1.81-1.3-2.55-2.13c-0.41-0.46-0.25-0.91,0.35-1.07c1.54-0.41,3.11-0.38,4.66-0.1C-17.84,2.03-17.63,2.34-17.69,2.88z M43.21-75.64c0.07-0.86,0.54-1.26,1.07-1.51c0.39-0.18,0.88-0.25,1.31-0.2c0.81,0.09,1.64,0.24,2.41,0.49c0.59,0.19,1.15,0.55,1.66,0.91c1.25,0.89,2.61,0.91,4.04,0.67c0.65-0.11,1.32-0.16,1.98-0.19c1.54-0.07,3.08-0.12,4.62-0.17c0.33-0.01,0.66,0.02,0.99,0.04c0,0.06,0.01,0.12,0.01,0.18c-0.18,0.06-0.36,0.15-0.55,0.17c-2.46,0.19-4.9,0.55-7.39,0.58c-1.62,0.02-3.01-0.36-4.32-1.27c-1.26-0.87-2.73-0.98-4.2-0.82c-0.4,0.04-0.77,0.42-1.14,0.67C43.57-76,43.46-75.87,43.21-75.64z M-36.95-75.68c-0.23-0.17-0.35-0.23-0.42-0.33c-0.49-0.67-1.17-0.84-1.96-0.82c-1.5,0.03-2.88,0.39-4.09,1.29c-0.84,0.63-1.78,0.89-2.83,0.86c-2.12-0.05-4.25-0.03-6.35-0.42c-0.52-0.1-1.06-0.07-1.59-0.13c-0.3-0.03-0.59-0.12-0.88-0.18c0.01-0.07,0.01-0.14,0.02-0.21c0.3-0.01,0.6-0.04,0.9-0.03c1.91,0.06,3.82,0.11,5.73,0.2c0.66,0.03,1.31,0.17,1.97,0.28c1.02,0.16,1.94-0.16,2.82-0.63c0.07-0.04,0.14-0.08,0.2-0.13c1.16-0.95,2.59-1.17,3.99-1.43c1.03-0.19,1.8,0.29,2.38,1.11C-37.02-76.14-37.02-75.97-36.95-75.68z M10.06-109.8c-0.25-0.12-0.35-0.15-0.42-0.21c-0.69-0.56-1.39-0.57-2.12-0.07c-0.74,0.5-1.54,0.21-2.32,0.16c-0.28-0.02-0.39-0.3-0.32-0.55c0.08-0.24,0.22-0.49,0.4-0.65c0.33-0.3,0.71-0.56,1.08-0.81c0.54-0.36,0.6-0.35,1.08,0.12c0.38,0.38,0.38,0.38,0.84,0.05c-0.12-0.22-0.27-0.44-0.37-0.68c-0.11-0.28,0.05-0.6,0.34-0.71c0.29-0.1,0.54-0.03,0.67,0.25c0.35,0.76,0.7,1.53,1.03,2.31C10.03-110.39,10.01-110.17,10.06-109.8z M14.09-103.35c0.04-0.39,0.09-0.77,0.14-1.25c0.65-0.03,1.22,0.28,1.97,0.58c-0.56,0.49-0.98,0.93-1.46,1.27c-0.18,0.13-0.52,0.1-0.76,0.05c-1.11-0.25-2.22-0.52-3.33-0.81c-0.19-0.05-0.44-0.19-0.48-0.33c-0.04-0.14,0.13-0.38,0.26-0.51c0.25-0.24,0.53-0.44,0.82-0.64c0.82-0.54,1.83-0.15,2.04,0.81C13.39-103.75,13.48-103.4,14.09-103.35z M18.46-101.16c-0.89-0.32-1.77-0.64-2.7-0.98c0.3-0.74,0.85-1.15,1.42-1.42c0.3-0.14,0.82,0.07,1.19,0.24c0.16,0.07,0.22,0.44,0.24,0.68c0.03,0.39,0,0.79-0.01,1.19C18.59-101.37,18.53-101.3,18.46-101.16z M8.26,128.48c0.37-0.37,3.07-1.33,3.78-1.35c0.21,0.89,0.17,0.97-0.67,1.26c-0.68,0.23-1.35,0.49-2.04,0.68C8.76,129.24,8.55,129.09,8.26,128.48z M26.48-9.42c-0.37,0-0.74,0.01-1.11,0c-0.3-0.01-0.52-0.14-0.52-0.48c0-0.35,0.23-0.45,0.53-0.45c0.77,0,1.54,0,2.31,0c0.28,0,0.55,0.06,0.57,0.41c0.02,0.39-0.27,0.49-0.58,0.5C27.28-9.41,26.88-9.42,26.48-9.42C26.48-9.42,26.48-9.42,26.48-9.42z M26.54-17.58c-0.37,0-0.74,0-1.11,0c-0.32,0-0.6-0.09-0.62-0.47c-0.02-0.38,0.24-0.5,0.57-0.5c0.74,0,1.49-0.01,2.23,0.02c0.3,0.01,0.62,0.09,0.59,0.49c-0.02,0.36-0.32,0.46-0.63,0.47C27.23-17.58,26.89-17.58,26.54-17.58C26.54-17.58,26.54-17.58,26.54-17.58z M10.89-70.95c-0.17-0.18-0.36-0.39-0.6-0.65c0.22-0.18,0.44-0.36,0.71-0.58c0.19,0.17,0.42,0.37,0.66,0.58C11.41-71.39,11.18-71.19,10.89-70.95z M-4.46-72.13c0.18,0.16,0.39,0.35,0.64,0.57c-0.25,0.22-0.47,0.41-0.7,0.62c-0.2-0.22-0.39-0.43-0.53-0.59C-4.89-71.69-4.69-71.89-4.46-72.13z M16.94-8.04C16.99-8.02,17.04-8,17.1-7.99c0.13-0.27,0.28-0.54,0.4-0.82c0.29-0.65,0.57-1.31,0.85-1.97c0.45-1.04,0.92-2.08,1.36-3.13c0.69-1.64,1.36-3.29,2.03-4.93c0.37-0.9,0.75-1.8,1.09-2.71c0.29-0.77,0.52-1.56,0.77-2.34c0.48-1.49,0.98-2.97,1.44-4.47c0.26-0.86,0.41-1.75,0.69-2.61c0.6-1.83,0.94-3.72,1.06-5.62c0.26-3.98-0.16-7.89-1.65-11.64c-0.31-0.77-0.75-1.41-1.37-1.92c-0.49-0.41-1.07-0.71-1.73-0.72c-0.7-0.01-1.1,0.37-1.1,1.07c0,0.26,0.04,0.53,0.09,0.79c0.17,0.83,0.34,1.66,0.53,2.49c0.62,2.63,0.47,5.29,0.2,7.93c-0.25,2.43-0.69,4.83-1.07,7.25c-0.29,1.86-0.59,3.73-0.89,5.59c-0.18,1.1-0.38,2.2-0.55,3.29c-0.22,1.36-0.41,2.73-0.64,4.09c-0.52,3.04-1.06,6.07-1.58,9.1C16.97-8.86,16.97-8.45,16.94-8.04z M9.94-46.05c-0.19,2.56,1.89,4.47,4.24,4.49c2.76,0.03,4.43-2.12,4.5-4.3c0.08-2.41-2.04-4.5-4.39-4.51C12.07-50.37,9.76-48.43,9.94-46.05z M-0.12-81.81c0.3,0.09,0.59,0.25,0.89,0.27c1.03,0.08,2.07,0.11,3.07-0.22l-0.02-0.01c-0.29,0.16-0.57,0.44-0.86,0.47c-0.79,0.07-1.59,0.05-2.38,0.01C0.28-81.31-0.07-81.4-0.12-81.81L-0.12-81.81z M-3.21-89.78 M-0.33-92.06c0.21-0.03,0.41-0.06,0.62-0.09c0.01,0.04,0.01,0.08,0.02,0.12C0.1-92-0.11-91.97-0.32-91.94C-0.32-91.98-0.33-92.02-0.33-92.06z M6.04-83.22c0.08,0.35-0.12,0.48-0.42,0.54c0,0,0.02,0.02,0.02,0.02c0.13-0.18,0.27-0.37,0.41-0.55C6.05-83.21,6.04-83.22,6.04-83.22z',
			truck: 'M-17.23,135.51V-38.74h-9.57v174.26H-17.23z M27.76-61.19c2.07,0,3.77-1.7,3.77-3.77v-16.59c0-2.07-1.7-3.77-3.77-3.77h-54.51c-2.07,0-3.77,1.7-3.77,3.77v16.59c0,2.07,1.7,3.77,3.77,3.77H27.76z M18.31-106.21c-0.22-1.17-0.45-2.33-0.67-3.5c-12.06,0-24.12,0-36.17,0c-1.17,5.24-2.34,10.48-3.51,15.72c-0.17,0.78-0.25,1.89,0.69,2.14c1.09,0.28,2.68-0.03,3.81-0.05c2.61-0.04,5.23-0.08,7.84-0.12c5.23-0.08,10.45-0.16,15.68-0.24c2.59-0.04,5.18-0.08,7.77-0.12c1.64-0.03,3.28-0.06,4.92-0.01c0.84,0.03,2.3,0.02,2.06-1.2C19.92-97.81,19.11-102.01,18.31-106.21z M-8.6-134.79c0-0.74-1.43-1.34-3.19-1.34s-3.19,0.6-3.19,1.34s1.43,1.34,3.19,1.34S-8.6-134.05-8.6-134.79z M17.4-134.79c0-0.74-1.43-1.34-3.19-1.34s-3.19,0.6-3.19,1.34s1.43,1.34,3.19,1.34S17.4-134.05,17.4-134.79z M8.91-134.72H-6.91 M29.34,135.21V-39.04h-9.57v174.26H29.34z M5.79,135.77V-38.49h-9.57v174.26H5.79z M-33.47-98.47l6,8.94c0,0,0.05,0.07,0.09,0.14c0.02-0.07,0.04-0.14,0.04-0.14s4.89-18.74,5.32-20.43c-0.05,0-0.09,0-0.09,0l-7.02,0.38c0,0-0.24,0.01-0.56,0.03c-0.46,1.38-3.78,11.33-3.78,11.33V-98.47z M25.26-92.98c0.29,1.37,0.52,2.46,0.65,3.06c0.37-0.38,0.62-0.63,0.62-0.63s5.94-5.94,6.9-6.9l-3.57-11.11c-1.01-0.16-7.61-1.07-8.14-1.14C22.08-108,24.13-98.34,25.26-92.98z M23.36-52.7v5.74c0,0,0,0.12,0,0.32c7.87,0,15.49,0,15.49,0c2.64,0,4.79,2.14,4.79,4.79v179.62c0,2.64-2.14,4.79-4.79,4.79c0,0-76.15,0-76.21,0c-2.52,0-4.79-2.27-4.79-4.79V-41.85c0-2.64,2.14-4.79,4.79-4.79c0,0,7.42,0,14.94,0c0-0.23,0-0.38,0-0.38v-5.74c-1.08,0-6.38,0-7.85,0c0-0.08,0-0.13,0-0.13s0-3.62,0-5.05c-0.14-0.18-0.25-0.31-0.25-0.31l-5.11-6.26c0,0-0.06-0.08-0.13-0.16c0-0.05,0-0.1,0-0.1s0-0.81,0-1.4c0,0,0-30.51,0-34.85c-0.23,0-0.38,0-0.38,0c-1.15,0-2.36-0.43-3.32,0.32c-0.88,0.68-1.7,1.47-2.54,2.21c-1.32,1.15-2.64,2.3-3.96,3.45c-0.17,0.15-0.64,0.71-0.87,0.66c-0.22-0.05-0.62-0.84-0.75-1.03c-0.52-0.72-1.03-1.45-1.49-2.21c-0.45-0.76-0.63-0.93,0.24-1.37c1.16-0.59,2.3-1.23,3.45-1.84c1.57-0.82,3.08-1.84,4.79-2.33c1.51-0.43,3.15-0.29,4.71-0.29c0.06-0.13,0.12-0.26,0.12-0.26l6.13-13.15c0,0,0.1-0.21,0.24-0.52c2.98-8.57,10.1-16.51,14.6-20.23c3.83,0,29.03,0,31.05,0c6.33,3.49,12.58,13.33,14.17,21.57c0,0,6.64,13.79,6.64,13.79c0.13,0,0.26,0,0.26,0c1.71,0,3.5-0.38,5.17,0.1c1.95,0.56,3.87,1.92,5.67,2.85c1.07,0.55,2.16,1.01,3.17,1.66c0.09,0.06,0.19,0.13,0.21,0.24c0.01,0.09-0.03,0.17-0.07,0.25c-0.64,1.18-1.25,2.38-1.93,3.54c-0.07,0.13-0.16,0.26-0.29,0.33c-0.49,0.26-1.51-0.95-1.84-1.23c-0.96-0.81-1.93-1.62-2.89-2.43c-1.17-0.99-2.35-1.97-3.52-2.96c-0.11-0.1-0.23-0.19-0.36-0.25c-0.72-0.32-2.04-0.06-2.83-0.06c0,0-0.06,0-0.13,0c0,0.06,0,0.13,0,0.13s0,33.63,0,37c-0.04,0.05-0.06,0.08-0.06,0.08s-4.47,5.62-4.48,5.64c0,0.91,0,3.64,0,4.77c-1.25,0-10.29,0-10.29,0L23.36-52.7z',
			bus: 'M18.04-1.33c1.55,0,2.8-1.25,2.8-2.8v-24.41c0-1.55-1.25-2.8-2.8-2.8h-34.19c-1.55,0-2.8,1.25-2.8,2.8v24.41c0,1.55,1.25,2.8,2.8,2.8H18.04z M17.72,53.75c1.55,0,2.8-1.25,2.8-2.8V26.53c0-1.55-1.25-2.8-2.8-2.8h-34.19c-1.55,0-2.8,1.25-2.8,2.8v24.41c0,1.55,1.25,2.8,2.8,2.8H17.72z M17.82,109.2c1.55,0,2.8-1.25,2.8-2.8V81.99c0-1.55-1.25-2.8-2.8-2.8h-34.19c-1.55,0-2.8,1.25-2.8,2.8v24.41c0,1.55,1.25,2.8,2.8,2.8H17.82z M27.45-52.97c0-2.95,0-19.63,0-19.63s0-0.44,0-0.88C8.73-91.09-23.96-79.83-25.91-72.8c0,0.54-0.01,0.94-0.01,0.94l-0.12,17.68c0,0,0,0.63-0.01,1.52c3.19-8.4,39.24-17.36,53.5,0.47c0-0.17,0-0.33,0-0.33S27.45-52.68,27.45-52.97z M36.72,66.16V24.26l-4.43,2.39l0.06,36.92L36.72,66.16z M36.72,114.58V72.69l-4.49,2.49l0.12,36.64L36.72,114.58z M36.9,18v-41.8l-4.49,2.39v37.1L36.9,18z M32.94-66.32c-0.34-1.29-0.71-2.59-1.12-3.9c0,0.7,0,1.39,0,1.39s0,36.32,0,38.39c0.2,0,0.35,0,0.35,0h4.13c0,0,0.32,0,0.65,0C36.57-32.16,37.85-47.83,32.94-66.32z M-30.58,112.56l0.12-37.66l-4.66-1.75v40.97L-30.58,112.56z M-30.29,64.22L-30.4,26.2l-4.66-1.75v41.8L-30.29,64.22z M-30.35,16.16v-38.12l-4.78-1.75v41.98L-30.35,16.16z M-30.29-65.54c0-1.76,0-2.82,0-2.82s0-0.29,0-0.57c-1.52,2.77-4.64,18.54-4.72,39.15c0.53,0,4.55,0,4.55,0s0.09,0,0.18,0c0-0.14,0-0.28,0-0.28S-30.29-56.7-30.29-65.54z M-10.39-133.73c0.11,1.1-4.13-0.09-8.8,1.31c-4.61,1.39-7.95,4.35-8.06,3.24c-0.11-1.1,3.25-4.41,7.88-5.56S-10.5-134.83-10.39-133.73z M28.55-129.24c-0.14,1.1-3.86-2.28-8.56-3.45c-4.64-1.15-8.42-0.14-8.29-1.24c0.14-1.1,4.02-2.41,8.63-1.04S28.69-130.34,28.55-129.24z M37.76,17.85c0,4.82,0,8.06,0,8.06l0,1.6l-0.16,91.82h-0.47h-1.89l-0.16,0.49c0,0,0,11.89,0,13.56c0.49,3.87-2.56,2.16-1.58,2.65c-0.18,0-0.31,0-0.31,0h-64.55c0,0-0.01,0-0.03,0c-1,0.23-1.86-0.87-1.86-2.27c0-0.25,0-0.43,0-0.43v-13.99c0,0,0-0.2,0-0.4c0,0-2.42,0-2.42,0s-0.43,0-0.86,0c0-0.15,0-0.3,0-0.3V-29.96c0,0,0-1.37,0-2.23c0.39-20.52,3.8-33.23,4.82-35.84c0-0.11-0.01-0.22-0.01-0.22s-0.1-3.92-0.12-4.66l-5.98,3.19c0,0-0.13,0.07-0.31,0.16c0.05,0.46,0.55,4.62,0.55,4.62s0.01,0.07,0.02,0.13c-0.28-0.01-0.57-0.01-0.57-0.01l-13.78-0.25c0,0-0.26,0-0.61-0.01c0.18-2.35-0.18-7.53,1.87-8.21c0,0,1.58-0.53,2.35-0.79c4.48-0.77,16.15-2.77,16.15-2.77s0.2-0.03,0.39-0.07c0-0.15,0-0.3,0-0.3s0-39.14,0-43.23c0.09-0.55,0.16-1.02,0.16-1.02c1.53-9.92,48.31-19.66,64.94-0.69c0,0.7,0,1.24,0,1.24v43.83c0,0,0,0.08,0,0.16c0.24,0.04,0.47,0.08,0.47,0.08l17.87,3.07c0,0,0.08,0.01,0.17,0.03c2.35,0.59,1.91,3.75,1.96,8.81c-1.51,0.01-13.7,0.12-13.7,0.12s-0.43,0-0.87,0l0.47-4.42c0,0,0.04-0.33,0.07-0.67c-0.08-0.03-0.15-0.07-0.15-0.07s-6.08-2.81-6.37-2.94c-0.01,0.42-0.01,0.73-0.01,0.73s-0.04,2.53-0.06,4.13c3.24,13.17,4.39,19.69,4.55,43.87v1.1C37.76-23.07,37.76,3.95,37.76,17.85z',	
			traveller: 'M18.04-1.33c1.55,0,2.8-1.25,2.8-2.8v-24.41c0-1.55-1.25-2.8-2.8-2.8h-34.19c-1.55,0-2.8,1.25-2.8,2.8v24.41c0,1.55,1.25,2.8,2.8,2.8H18.04z M17.72,53.75c1.55,0,2.8-1.25,2.8-2.8V26.53c0-1.55-1.25-2.8-2.8-2.8h-34.19c-1.55,0-2.8,1.25-2.8,2.8v24.41c0,1.55,1.25,2.8,2.8,2.8H17.72z M17.82,109.2c1.55,0,2.8-1.25,2.8-2.8V81.99c0-1.55-1.25-2.8-2.8-2.8h-34.19c-1.55,0-2.8,1.25-2.8,2.8v24.41c0,1.55,1.25,2.8,2.8,2.8H17.82z M27.45-52.97c0-2.95,0-19.63,0-19.63s0-0.44,0-0.88C8.73-91.09-23.96-79.83-25.91-72.8c0,0.54-0.01,0.94-0.01,0.94l-0.12,17.68c0,0,0,0.63-0.01,1.52c3.19-8.4,39.24-17.36,53.5,0.47c0-0.17,0-0.33,0-0.33S27.45-52.68,27.45-52.97z M36.72,66.16V24.26l-4.43,2.39l0.06,36.92L36.72,66.16z M36.72,114.58V72.69l-4.49,2.49l0.12,36.64L36.72,114.58z M36.9,18v-41.8l-4.49,2.39v37.1L36.9,18z M32.94-66.32c-0.34-1.29-0.71-2.59-1.12-3.9c0,0.7,0,1.39,0,1.39s0,36.32,0,38.39c0.2,0,0.35,0,0.35,0h4.13c0,0,0.32,0,0.65,0C36.57-32.16,37.85-47.83,32.94-66.32z M-30.58,112.56l0.12-37.66l-4.66-1.75v40.97L-30.58,112.56z M-30.29,64.22L-30.4,26.2l-4.66-1.75v41.8L-30.29,64.22z M-30.35,16.16v-38.12l-4.78-1.75v41.98L-30.35,16.16z M-30.29-65.54c0-1.76,0-2.82,0-2.82s0-0.29,0-0.57c-1.52,2.77-4.64,18.54-4.72,39.15c0.53,0,4.55,0,4.55,0s0.09,0,0.18,0c0-0.14,0-0.28,0-0.28S-30.29-56.7-30.29-65.54z M-10.39-133.73c0.11,1.1-4.13-0.09-8.8,1.31c-4.61,1.39-7.95,4.35-8.06,3.24c-0.11-1.1,3.25-4.41,7.88-5.56S-10.5-134.83-10.39-133.73z M28.55-129.24c-0.14,1.1-3.86-2.28-8.56-3.45c-4.64-1.15-8.42-0.14-8.29-1.24c0.14-1.1,4.02-2.41,8.63-1.04S28.69-130.34,28.55-129.24z M37.76,17.85c0,4.82,0,8.06,0,8.06l0,1.6l-0.16,91.82h-0.47h-1.89l-0.16,0.49c0,0,0,11.89,0,13.56c0.49,3.87-2.56,2.16-1.58,2.65c-0.18,0-0.31,0-0.31,0h-64.55c0,0-0.01,0-0.03,0c-1,0.23-1.86-0.87-1.86-2.27c0-0.25,0-0.43,0-0.43v-13.99c0,0,0-0.2,0-0.4c0,0-2.42,0-2.42,0s-0.43,0-0.86,0c0-0.15,0-0.3,0-0.3V-29.96c0,0,0-1.37,0-2.23c0.39-20.52,3.8-33.23,4.82-35.84c0-0.11-0.01-0.22-0.01-0.22s-0.1-3.92-0.12-4.66l-5.98,3.19c0,0-0.13,0.07-0.31,0.16c0.05,0.46,0.55,4.62,0.55,4.62s0.01,0.07,0.02,0.13c-0.28-0.01-0.57-0.01-0.57-0.01l-13.78-0.25c0,0-0.26,0-0.61-0.01c0.18-2.35-0.18-7.53,1.87-8.21c0,0,1.58-0.53,2.35-0.79c4.48-0.77,16.15-2.77,16.15-2.77s0.2-0.03,0.39-0.07c0-0.15,0-0.3,0-0.3s0-39.14,0-43.23c0.09-0.55,0.16-1.02,0.16-1.02c1.53-9.92,48.31-19.66,64.94-0.69c0,0.7,0,1.24,0,1.24v43.83c0,0,0,0.08,0,0.16c0.24,0.04,0.47,0.08,0.47,0.08l17.87,3.07c0,0,0.08,0.01,0.17,0.03c2.35,0.59,1.91,3.75,1.96,8.81c-1.51,0.01-13.7,0.12-13.7,0.12s-0.43,0-0.87,0l0.47-4.42c0,0,0.04-0.33,0.07-0.67c-0.08-0.03-0.15-0.07-0.15-0.07s-6.08-2.81-6.37-2.94c-0.01,0.42-0.01,0.73-0.01,0.73s-0.04,2.53-0.06,4.13c3.24,13.17,4.39,19.69,4.55,43.87v1.1C37.76-23.07,37.76,3.95,37.76,17.85z'
		},		
		iconColor : {
				Stopping : '#ff0000',
				Idling : "#ffcf36",
				Moving : "#7fbb01",
				OverSpeed : "#0000ff",
				Unknown : "#d3d3d3"
					},
		initMapPointer : function(div, zoomIndex, center) {
			if (typeof center === "undefined") {
				center = {
					lat : 28.66,
					lng : 77.13
				};
			}
			var directionsDisplay = new google.maps.DirectionsRenderer;
			var map = new google.maps.Map(div, {
				disableDefaultUI : true,
				scrollwheel : false,
				zoomControl : true,
				zoom : (typeof zoomIndex === 'undefined') ? 6 : zoomIndex,
				center : center,
				fullscreenControl : true,
			});
			directionsDisplay.setMap(map);
			return {
				map : map,
				directionsDisplay : directionsDisplay,
				directionService : $directionService.get()
			}
		},
		isOldPosition : function(point){
			var deviceTime = moment.utc(point.deviceTime, "YYYY-MM-DD HH:mm:ss").local();
			var now = moment();
			var diffInMinutes = now.diff(deviceTime, 'minute');
			var strength =  this.signalStrength(diffInMinutes);
			return strength === 0;
		},
		signalStrength : function(minutes){
			var range =  [ 10, 8, 6, 4, 2 , 0];
			var strength = -1;
			for(var i=0;i<range.length;i++){
				if(minutes>=range[i]){
					strength = i;
					break;
				}
			}
			return strength;
		},		
		getStrengthFromPoint : function(point){
			var lastUpdate = moment.utc(point.lastUpdate, "YYYY-MM-DD HH:mm:ss").local();
			var now = moment();
			var diffInMinutes = now.diff(lastUpdate, 'minute');
			return this.signalStrength(diffInMinutes);				
		},
		getTruckStatusBase: function (truck) {
	    	var strength = this.getStrengthFromPoint(truck);
			if (strength == 0) {
				return "Unknown";
			}

			if (this.isOldPosition(truck)) {
				return "Stopping";
			}

			if (truck.speed > 0) {
				return "Moving";
			}

			var attributes = truck.attributes;
			if (truck.attributes === null) {
				return "Stopping";
			}
			if ((attributes.indexOf('"io239":1') !== -1) || (attributes.indexOf('"ignition":1') !== -1) || (attributes.indexOf('"ignition":true') !== -1)) {
				return "Idling";
			}
			return "Stopping";
	    },
		pinSymbol : function(color, type, rotation, status, scale) {
			if (typeof type === "undefined" || type === null) {
				type = 'icon';
			}
			if (typeof rotation === "undefined" || rotation === null) {
				rotation = 0;
			}
			if (typeof status !== "undefined") {
				color = this.iconColor[status];
			}
			
			if (typeof scale === "undefined") {
				scale = 0.4
			}
			return {
				path : this.paths[type],
				fillColor : color,
				fillOpacity : 1,
				strokeColor : '#000',
				strokeWeight : 1,
				scaledSize : new google.maps.Size(50, 50),
				scale : scale,
				rotation : rotation,
				labelOrigin : new google.maps.Point(0, -29)
			};
		},
		getGeofenceData : function(data) {
			var gdata = {}
			if (data.startsWith("CIRCLE")) {
				gdata.type = "CIRCLE";
				var len = data.length;
				var start = data.indexOf("(") + 1;
				var end = len - start - 1;
				var attr = data.substr(start, end);
				var sp = attr.split(",");
				var radius = parseFloat(sp[1]);
				var center = sp[0].split(" ");
				gdata.center = {
					lat : parseFloat(center[0]),
					lng : parseFloat(center[1])
				};
				gdata.radius = radius;
			} else if (data.startsWith("LINESTRING")) {
				gdata.type = "LINE";
			}
			return gdata;
		},
		interpolateMarkerPosition:  function(marker, stepdata) {
			var percent = stepdata.curstep / stepdata.steps;
			var lat = stepdata.start.latitude + percent * (stepdata.end.latitude - stepdata.start.latitude);
            var lng = stepdata.start.longitude + percent * (stepdata.end.longitude - stepdata.start.longitude);
            var latlng = new google.maps.LatLng(lat, lng);
            marker.setPosition(latlng);	    
            stepdata.curstep +=1;            
        },
		moveMarker: function(marker, destination, duration){
			  var steps = 100;
			  var origin = marker.getPosition();
			  var pos1 = {
				latitude: origin.lat(),
				longitude: origin.lng()
			  };						  
			  var delay =  duration/steps;
			  var stepdata = {
					  curstep: 1,
					  steps: steps,
					  delay: delay,
					  start: pos1,
					  end: destination
			  };
			  if(marker.interval !== 'undefined' && marker.interval!=null){
				  $interval.cancel(marker.interval);
			  }
	          marker.interval = $interval(this.interpolateMarkerPosition, delay, steps, false, marker, stepdata);
		},
		addMarker : function(map, config, callback, callbackData) {
			var markerOption = {
				position : config.latlng,
				map : map,
				icon : this.pinSymbol(config.color, config.type)
			};
			markerOption['zIndex'] = config.zIndex;
			var marker = new google.maps.Marker(markerOption);
			if (typeof callback === 'function') {
				marker.addListener('click', function() {
					callback(config.index, callbackData);
				});
			}
			marker.config = config;
			return marker;
		},
		addPositionAsMarker : function(device, positions, map, callback, callbackData, fitBounds) {
			device.pathBounds = new google.maps.LatLngBounds();
			if (typeof device.markers === 'undefined' || device.markers == null) {
				device.markers = [];
			}
			var startMarker = device.markers.length;
			if (typeof fitBounds === 'undefined') {
				fitBounds = true;
			}
			for (var i = 0; i < positions.length; i++) {
				var point = positions[i];
				var color = '#7fbb01';
				if (typeof point.color !== 'undefined') {
					color = point.color;
				}
				var latlng = new google.maps.LatLng(point.latitude, point.longitude);
				device.pathBounds.extend(latlng);
				var heading = "Point " + (i + 1);
				if (typeof point.heading !== 'undefined') {
					heading = point.heading;
				}
				var config = {
					index : startMarker + i,
					heading : heading,
					latlng : latlng,
					color : color,
					point : point
				};
				var marker = this.addMarker(map, config, callback, callbackData);
				device.markers.push(marker);
			}
			if (fitBounds) {
				map.fitBounds(device.pathBounds);
			}
		},
		addPositionAsPolyLine : function(device, positions, map, callback, callbackData, fitBounds, strokeColor, icons) {
			if (typeof fitBounds === 'undefined') {
				fitBounds = true;
			}
			var heatMapData = [];
			var polylinePath = [];
			var pathBounds = new google.maps.LatLngBounds();
			for (var i = 0; i < positions.length; i++) {
				var point = positions[i];
				var latlng = new google.maps.LatLng(point.latitude, point.longitude);
				var weight = 0.5;
				// if speed defined
				if (point.speed > 0) {
					weight = 1;
				}
				heatMapData.push({
					location : latlng,
					weight : weight
				});
				polylinePath.push(latlng);
				pathBounds.extend(latlng);
			}
			if (fitBounds) {
				map.fitBounds(pathBounds);
			}
			var color = '#0000FF';
			if (typeof strokeColor !== 'undefined') {
				color = strokeColor;
			}
			var config = {
				path : polylinePath,
				strokeColor : color,
				strokeOpacity : 1,
				strokeWeight : 5
			};
			if (typeof icons !== 'undefined' && icons !== null) {
				config.icons = icons;
			}
			var polyline = new google.maps.Polyline(config);
			polyline.setMap(map);
			var heatmap = new google.maps.visualization.HeatmapLayer({
				data : heatMapData
			});
			heatmap.setMap(map);
			device.polyline = polyline;
			device.heatmap = heatmap;
			device.pathBounds = pathBounds;
		},
		addPosition : function(device, positions, map, callback, callbackData, fitBounds) {
			this.addPositionAsPolyLine(device, positions, map, callback, callbackData, fitBounds);
			this.addPositionAsMarker(device, positions, map, callback, callbackData, fitBounds);
		},
		addSinglePositionAsMarker : function(device, position, map, callback, callbackData, color, type) {
			var latlng = new google.maps.LatLng(position.latitude, position.longitude);
			device.pathBounds.extend(latlng);
			map.fitBounds(device.pathBounds);
			var index = device.markers.length;
			var heading = "Point " + index;
			
			if(typeof color === 'undefined' || color ===null){
				color = '#7fbb01';
			}
			
			if(typeof type === 'undefined' || type ===null){
				type = 'icon';
			}
			var config = {
				index : index,
				heading : heading,
				latlng : latlng,
				color : color,
				point : position,
				type: type
			};
			var marker = this.addMarker(map, config, callback, callbackData);
			device.markers.push(marker);
			return marker;
		},
		clearPolyLine : function(device) {
			var polyline = device.polyline;
			if (typeof polyline !== "undefined" && polyline !== null) {
				polyline.setMap(null);
				device.polyline = null;
			}
			var heatmap = device.heatmap;
			if (typeof heatmap !== "undefined" && heatmap !== null) {
				heatmap.setMap(null);
				device.heatmap = null;
			}
		},
		clearMarkers : function(device) {
			var markers = device.markers;
			if (typeof markers !== "undefined" && markers !== null) {
				for (var i = 0; i < markers.length; i++) {
					markers[i].setMap(null);
				}
			}
			device.markers = null;
		},
		clearAll : function(device) {
			this.clearPolyLine(device);
			this.clearMarkers(device);
		},
		getMarker : function(latitude, longitude) {
			return new google.maps.Marker({
				position : new google.maps.LatLng(latitude, longitude),
			});
		},
		showRouteWithWayPoint : function(mapObj, origin, destination, midpoints) {
			var directionsService = mapObj.directionService;
			var waypoints = [];
			for (var i = 0; i < midpoints.length; i++) {
				var point = midpoints[i];
				waypoints.push({
					location : this.getMarker(point.lat, point.lng).getPosition(),
					stopover : true
				});
			}
			var originMarker = this.getMarker(origin.lat, origin.lng);
			var destinationMarker = this.getMarker(destination.lat, destination.lng);
			directionsService.route({
				origin : originMarker.getPosition(),
				destination : destinationMarker.getPosition(),
				waypoints : waypoints,
				optimizeWaypoints : false,
				travelMode : 'DRIVING'
			}, function(response, status) {
				if (status === 'OK') {
					mapObj.directionsDisplay.setOptions({
						'suppressMarkers' : true,
						'preserveViewport' : true
					});
					mapObj.directionsDisplay.setDirections(response);
				}
			});
		}
	}
}).factory('imageService', function() {
	return {
		getImageSvg: function (color, zoom, angle, category) {
	        var i, info, svg, width, height, rotateTransform, scaleTransform, fill;

	        info = Ext.getStore('DeviceImages').findRecord('key', category || 'default', 0, false, false, true);
	        if(info === null  || typeof info === 'undefined'){
	            info = Ext.getStore('DeviceImages').findRecord('key', 'car' || 'default', 0, false, false, true);
	        }

	        
	        svg = Ext.clone(info.get('svg'));
	        if (!svg) {
	            svg = this.cloneDocument(info.get('svg'));
	        }

	        width = parseFloat(svg.documentElement.getAttribute('width'));
	        height = parseFloat(svg.documentElement.getAttribute('height'));

	        fill = info.get('fillId');
	        if (!Ext.isArray(fill)) {
	            fill = [fill];
	        }
	        for (i = 0; i < fill.length; i++) {
	            svg.getElementById(fill[i]).style.fill = color;
	        }

	        rotateTransform = 'rotate(' + angle + ' ' + (width / 2) + ' ' + (height / 2) + ')';
	        svg.getElementById(info.get('rotateId')).setAttribute('transform', rotateTransform);

	        if (zoom) {
	            width *= Traccar.Style.mapScaleSelected;
	            height *= Traccar.Style.mapScaleSelected;
	            scaleTransform = 'scale(' + Traccar.Style.mapScaleSelected + ') ';
	        } else {
	            width *= Traccar.Style.mapScaleNormal;
	            height *= Traccar.Style.mapScaleNormal;
	            scaleTransform = 'scale(' + Traccar.Style.mapScaleNormal + ') ';
	        }

	        if (info.get('scaleId') !== info.get('rotateId')) {
	            svg.getElementById(info.get('scaleId')).setAttribute('transform', scaleTransform);
	        } else {
	            svg.getElementById(info.get('scaleId')).setAttribute('transform', scaleTransform + ' ' + rotateTransform);
	        }

	        svg.documentElement.setAttribute('width', width);
	        svg.documentElement.setAttribute('height', height);
	        svg.documentElement.setAttribute('viewBox', '0 0 ' + width + ' ' + height);

	        return svg;
	    },
	    formatSrc: function (svg) {
	        return 'data:image/svg+xml;charset=utf-8,' +
	                encodeURIComponent(new XMLSerializer().serializeToString(svg.documentElement));
	    },

	    cloneDocument: function (svgDocument) {
	        var newDocument, newNode;
	        newDocument = svgDocument.implementation.createDocument(svgDocument.namespaceURI, null, null);
	        newNode = newDocument.importNode(svgDocument.documentElement, true);
	        newDocument.appendChild(newNode);
	        return newDocument;
	    },

	    getImageIcon: function (color, zoom, angle, category) {
	        var image, svg, width, height;

	        svg = this.getImageSvg(color, zoom, angle, category);
	        width = parseFloat(svg.documentElement.getAttribute('width'));
	        height = parseFloat(svg.documentElement.getAttribute('height'));

	        image =  new ol.style.Icon({
	            imgSize: [width, height],
	            src: this.formatSrc(svg)
	        });
	        image.fill = color;
	        image.zoom = zoom;
	        image.angle = angle;
	        image.category = category;

	        return image;
	    }
	};
});
